import Alpine from 'alpinejs';
import Swiper from 'swiper';
import {SwiperOptions,} from 'swiper/types';
import { Navigation, Keyboard, Pagination } from 'swiper/modules';

import 'swiper/swiper.css';
import 'swiper/css/pagination';

document.addEventListener('alpine:init', () => {
    Alpine.data('initProductSelection', () => {
        return {
            swiper: {},
            version2: false,
            init() {
                this.version2 = this.$refs.swiperContainer.dataset.version && this.$refs.swiperContainer.dataset.version == '2' ? true : false
                const swiperParams: SwiperOptions = {
                    modules: [Navigation, Keyboard, Pagination],
                    init: false,
                    spaceBetween: this.version2 ? 8 :16,
                    slidesPerView: this.version2 ? 1.2 : 1,
                    keyboard: {
                        enabled: true,
                    },
                    navigation: {
                        prevEl: this.$refs.buttonPrev,
                        nextEl: this.$refs.buttonNext,
                    },
                    pagination: {
                        clickable: true,
                        el: this.$refs.pagination,
                        type: 'progressbar',
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 1.8,
                        },
                        1024: {
                            slidesPerView: 2.6,
                            spaceBetween: this.version2 ? 26 : 16
                        },
                        1280: {
                            slidesPerView: 3.2,
                            spaceBetween: this.version2 ? 26 : 16
                        },
                    },
                };

                const swiper = new Swiper(
                    this.$refs.swiperContainer,
                    swiperParams,
                );
                this.swiper = swiper;

                this.$nextTick(() => {
                    swiper.init();
                });
            },
        };
    });
});
